import { createContext } from 'react';

export const alertsPerDayContext = createContext();